import enTranslation from './locales/en.json';
import esTranslation from './locales/es.json';
import deTranslation from './locales/de.json';
import frTranslation from './locales/fr.json';
import ptTranslation from './locales/pt.json';
import { platformName } from '../partials/ua';

const testPlans = [
  {
    period: "1 month",
    amount: 9.99,
    currency: "USD",
    currencySign: "$",
    skuId: 2355827,
    storeId: 16655,
  },
  {
    period: "6 months",
    amount: 19.99,
    currency: "USD",
    currencySign: "$",
    skuId: 2355823,
    storeId: 16655,
  },
  {
    period: "One-time fee",
    amount: 39.99,
    currency: "USD",
    currencySign: "$",
    skuId: 2355829,
    storeId: 16655,
  },
];

const winPlans = [
  {
    period: "1 month",
    amount: 4.99,
    currency: "USD",
    currencySign: "$",
    skuId: 4087972,
    storeId: 548375,
  },
  {
    period: "6 months",
    amount: 19.99,
    currency: "USD",
    currencySign: "$",
    skuId: 4087934,
    storeId: 548375,
  },
  {
    period: "One-time fee",
    amount: 39.99,
    currency: "USD",
    currencySign: "$",
    skuId: 4087932,
    storeId: 548375,
  },
];

const macPlans = [
  {
    period: "1 month",
    amount: 9.99,
    currency: "USD",
    currencySign: "$",
    skuId: 4088276,
    storeId: 548375,
  },
  {
    period: "6 months",
    amount: 19.99,
    currency: "USD",
    currencySign: "$",
    skuId: 4087962,
    storeId: 548375,
  },
  {
    period: "One-time fee",
    amount: 39.99,
    currency: "USD",
    currencySign: "$",
    skuId: 4087924,
    storeId: 548375,
  },
];

let plans = [];

if (process.env.ENV === 'test') {
  plans = testPlans;
} else {
  plans = platformName === 'win' ? winPlans : macPlans;
}

export { plans };

export const localeResources = {
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  de: { translation: deTranslation },
  fr: { translation: frTranslation },
  pt: { translation: ptTranslation },
}
